import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Popover, message, Form, Select, Checkbox } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import CheckboxList from "./b2b/CheckboxList";
import moment from "moment";
import { AppModal, AppTable } from "../common";

interface Contentdata {
  full_name?: string;
  email: number;
  package_name: string;
  request_type: string;
  userId:string;
  company: {
    name: string;
    
  };
  user: {
    _id: string;
    full_name: string;
    email: string;
  };
  _id: string;
  reference_id: string;
  isComplete: boolean;
}

interface DataTableProps {
  // setshowModel: (value: boolean) => void;
  // deleteDepartment: any;
  // isOpen: boolean;
  contentData: Contentdata[];
  refreshPlanChanges?: () => void;
}

type PackagePricing = {
  packageAmount: number;
  igstTax: number;
  cgstTax: number;
  sgstTax: number;
  subTotalAmount: any; // or number if you don't use toFixed()
};

function PlanChangeTable({ contentData, refreshPlanChanges }: DataTableProps) {
  const {
    setAllPackageList,
    allPackageList,
    selectedModulesList,
    selectedModulesListP2,
  } = useB2BContext();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState<any>();
  const [isEmployees, setEmployees] = useState<any>(0);
  const [isPricePerPerson, setPricePerPerson] = useState<any>(0);
  const [paymentDuration, setPaymentDuration] = useState("");
  const [mapModuleAccessList, setMapModuleAccessList] = useState();
    const { getUserByID } = useB2BContext();
  const [disabledPacageDropdown, setDisabledPacageDropdown] = useState(false);
  const [packagePricingBreakdown, setPackagePricingBreakDown] = useState<any>(
    {}
  );
  const [btnDisable, setBtnDisable] = useState(true);
  const [packageId, setPackageId] = useState<any>("");
  const [pacakageName, setPacakageName] = useState<any>("");
  const [requestType, setRequestType] = useState<any>("");

  const [memberModules, setMemberModules] = useState<any>([]);
  const [preSelectPackages, setPreSelectPackages] = useState<any>([]);
  const [isAmount, setIsAmount] = useState<any>(0);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const { Option } = Select;

  useEffect(() => {
    console.log(contentData, "contentData");
  }, [contentData]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setUserData(undefined);
    setEmployees(0);
    setPricePerPerson(0);
    setPaymentDuration("");
    setMapModuleAccessList(undefined);
    setDisabledPacageDropdown(false);
    setPackagePricingBreakDown({});
    setBtnDisable(true);
    setPackageId("");
    setPacakageName("");
    setRequestType("");
    setPreSelectPackages([]);
    setIsAmount(0);
  };

  useEffect(() => {
    console.log(memberModules, "memberModules");
  }, [memberModules]);

  const ApprovCompany = (id: any, status: any) => {
    authSVC
      .requestUpgradePlan(id, { status: status })
      .then((res: any) => {
        message.success(res.data.message);
        refreshPlanChanges?.();
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  const getUserData = async (uemail: string) => {
    authSVC
      .getByUEmail(uemail)
      .then((res: any) => {
        setUserData(res.data.data);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const AllPackage = async () => {
    authSVC
      .getAllPackage()
      .then((res: any) => {
        setAllPackageList(res.data.package);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  useEffect(() => {
    allPackageList &&
      allPackageList?.map((data: any) => {
        console.log(data, "data");
        console.log(pacakageName, "pacakageName333");
        if (data.package === pacakageName) {
          console.log(data._id, "LLKKKKKKKK");
          setPackageId(data._id);
        }
      });
  }, [allPackageList, pacakageName]);

  const onFinish = (values: {
    package_name: string;
    package_name_p2: string;
    package_price: string;
    package_price_p2: string;
    unitPrice: string;
  }) => {
    console.log(values.package_name, values,"package_price");
   const pkgDetails = {
  company_id: userData?.company_id?._id,
  addons: [
    {
      package: {
        package_id: packageId,
        price: isAmount,
        unit_price_per_employee: isPricePerPerson,
        total_unit_employee: isEmployees,
        package_duration: paymentDuration,
      },
      mapModuleAccess: mapModuleAccessList,
    },
  ],
};

    authSVC
      .postMapModules(pkgDetails)
      .then((res: any) => {
        message.success("Payment Details Added");
        handleCancel();
        refreshPlanChanges?.();
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const handleChange = (value: string) => {
    setPackageId(value);
    form.setFieldsValue({
      package_price: "",
      employees: "",
      unitPrice: "",
      duration: "",
    });
    setIsAmount(0);
    setPackagePricingBreakDown({});
  };

  const onChangePackageAmount = (e: any) => {
    setIsAmount(e.target.value);
    setPackagePricingBreakDown({});
    let tempPackagePricing = packagePricingBreakdown;
    const packageAmount = e.target.value;
    console.log(packageAmount, "packageAmount 1");
    tempPackagePricing.packageAmount = packageAmount;
    tempPackagePricing.igstTax = packageAmount * 0.18;
    tempPackagePricing.cgstTax = packageAmount * 0.09;
    tempPackagePricing.sgstTax = tempPackagePricing.packageAmount * 0.09;
    tempPackagePricing.subTotalAmount =
      parseInt(tempPackagePricing.packageAmount) +
      parseInt(tempPackagePricing.igstTax);
    setPackagePricingBreakDown(tempPackagePricing);
  };

  const onChangeEmployees = (e: any) => {
    const newEmployee = Number(e.target.value);
    setEmployees(newEmployee);

    const isEmployeesNum = newEmployee;
    const Package1Amount = isPricePerPerson * isEmployeesNum;
    const subTotal = Package1Amount + Package1Amount * 0.18;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: Package1Amount,
      igstTax: Package1Amount * 0.18,
      cgstTax: Package1Amount * 0.09,
      sgstTax: Package1Amount * 0.09,
      subTotalAmount: parseFloat(subTotal.toFixed(2)), // ✅ store as number
    };

    setPackagePricingBreakDown(updatedPackagePricing);
    setIsAmount(subTotal.toFixed(2)); // ✅ set formatted string separately
  };

  const handleChangeDuration = (value: any) => {
    setPaymentDuration(value);
    console.log(value);
  };

  const onChangePricePerPerson = (e: any) => {
    const newPricePerPerson = Number(e.target.value);
    setPricePerPerson(newPricePerPerson);

    const isEmployeesNum = Number(isEmployees);
    const Package1Amount = newPricePerPerson * isEmployeesNum;

    const subTotal = Package1Amount + Package1Amount * 0.18;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: Package1Amount,
      igstTax: Package1Amount * 0.18,
      cgstTax: Package1Amount * 0.09,
      sgstTax: Package1Amount * 0.09,
      subTotalAmount: parseFloat(subTotal.toFixed(2)), // Store as number
    };

    setPackagePricingBreakDown(updatedPackagePricing);
    setIsAmount(subTotal.toFixed(2)); // Use formatted string if needed for display
  };

  const VerifiedPackage = (event: any) => {
    if (event.target.checked === true) {
      setBtnDisable(false);
    } else {
      setBtnDisable(true);
    }
  };

  const AllModule = async () => {
    authSVC
      .getAllModule()
      .then((res: any) => {
        setMemberModules(res.data.modules);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const addPaymentDetails = (
    uemail: any,
    packagename: any,
    requesttype: any
  ) => {
    console.log(packagename, "packagename Set");
    setIsModalOpen(true);
    getUserData(uemail);
    setPacakageName(packagename);
    setRequestType(requesttype);
    AllModule();
    AllPackage();

    form.setFieldsValue({
      package_name: packagename,
    });
  };

  useEffect(() => {
    if (packageId && userData) {
      setTimeout(() => {
        authSVC
          .GetModules(userData?.company_id?._id, packageId)
          .then((res: any) => {
            setPreSelectPackages(res.data.pre_select_packages);
            console.log(
              res.data.pre_select_packages,
              "res.data.pre_select_packages"
            );
          })
          .catch((err: any) => {
            message.error(err.message);
          });
      }, 1000);
    }
  }, [packageId, userData]);

  // requestUpgrade/updateStatus/:requestID

  const columns: ColumnsType<Contentdata> = [
    {
      title: "Reference ID",
      dataIndex: "reference_id",
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      render: (record) => <div className="truncate">{record}</div>,
      onFilter: (value, record) => {
        return (
          String(record?.company)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.package_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.full_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.reference_id)
            .toLowerCase()
            .includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Business Name",
      dataIndex: "company",
      key: "company",

      render: (record) => <div className="truncate">{record}</div>,
      // sorter: (a: any, b: any) => a._id.localeCompare(b.company),
      ellipsis: true,
    },
    {
      title: "Name",
      dataIndex: "full_name",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Request Type",
      dataIndex: "request_type",
      key: "request_type",
      render: (record) => (
        <div className="truncate">
          {record === "upgrade" ? "Upgrade Plan" : "Another Plan"}
        </div>
      ),
    },
    {
      title: "Plan Details",
      dataIndex: "package_name",
      key: "package_name",
      render: (record) => <div className="truncate">{record}</div>,
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    // {
    //   title: "Request Type",
    //   dataIndex: "request_type",
    //   key: "request_type",
    //   render: (record) => (
    //     <div className="truncate">{record?.user?.request_type}</div>
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space style={{ margin: "0 auto" }}>
          {/* {record.isComplete ? (
            <Button disabled={record.isComplete ? true : false}>
              Approved
            </Button>
          ) : (
            <Popover
              content={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: "#479751",
                      color: "#fff",
                      width: "100%",
                    }}
                    onClick={() => ApprovCompany(record._id, "approved")}
                  >
                    Yes
                  </Button>
                </div>
              }
              title="Please Double click to delete."
            >
              <Button disabled={record.isComplete ? true : false}>
                Approve
              </Button>
            </Popover>
          )} */}
          <Button
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
            onClick={() =>
              addPaymentDetails(
                record?.userId,
                record?.package_name,
                record?.request_type
              )
            }
          >
            Edit
          </Button>
          {/* {record.isComplete ? }
          <Button
            style={{
              backgroundColor: "#F5F5F5",
              color: "#FF1F00",
              fontWeight: "600",
            }}
            onClick={() => ApprovCompany(record._id, "rejected")}
          >
            Reject
          </Button> */}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="dataTable">
        <div className="filterMenu">
          <div></div>
          <Input.Search
            onSearch={(value) => {
              setSearchText(value.toLowerCase());
            }}
            onChange={(e) => {
              setSearchText(e.target.value.toLowerCase());
            }}
            className="searchField"
            placeholder="Search here..."
          />
        </div>
        <AppTable
          className="dataGrid"
          columns={columns}
          dataSource={contentData}
        />
      </div>

      <AppModal
        title={requestType === "upgrade" ? "Upgrade Package" : "Assign Additional Package"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="add_pacakge_popup"
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          form={form}
          style={{ marginTop: "25px" }}
        >
          {allPackageList && (
            <Form.Item
              label="Choose Package"
              name="package_name"
              rules={[
                {
                  required: true,
                  message: "Please choose the package",
                },
              ]}
              className="form_item_blue"
            >
              <Select
                disabled={true}
                onChange={handleChange}
                options={allPackageList
                  // .filter((option: any) => option._id !== packageIdP2) // Filter out the excluded ID
                  .map((option: any) => ({
                    value: option._id,
                    label: option.package,
                  }))}
                placeholder="Please choose the package"
              />
            </Form.Item>
          )}
          <Form.Item
            label="Contract Duration"
            name="duration"
            rules={[
              {
                required: true,
                message: "Please Choose The Package Duration",
              },
            ]}
            className="form_item_blue"
          >
            <Select
              onChange={handleChangeDuration}
              placeholder="Please choose the package duration"
            >
              <option value="12months">12 Months</option>
              <option value="24months">24 Months</option>
            </Select>
          </Form.Item>
          {/* <Form.Item
            label={
              <>
                Package Amount
                <i style={{ fontWeight: "normal" }}>(18% GST Tax excluded)</i>
              </>
            }
            name="package_price"
            rules={[
              {
                required: true,
                message: "Please Enter Amount",
              },
              {
                pattern: new RegExp(/^[0-9\b]+$/),
                message: "Please enter valid number!",
              },
            ]}
            className="form_item_blue"
          >
            <Input
              onChange={onChangePackageAmount}
              placeholder="Please Enter Amount"
            />
          </Form.Item> */}
          <Form.Item
            label="Employees (Units)"
            name="employees"
            rules={[
              {
                required: true,
                message: "Please Enter the number of employees",
              },
              {
                pattern: new RegExp(/^[0-9\b]+$/),
                message: "Please enter valid number!",
              },
            ]}
            className="form_item_blue"
          >
            <Input
              onChange={onChangeEmployees}
              placeholder="Please Enter the number of employees"
            />
          </Form.Item>
          <Form.Item
            label={
              <>
                Price Per Person
                <i style={{ fontWeight: "normal" }}>(18% GST Tax excluded)</i>
              </>
            }
            name="unitPrice"
            rules={[
              {
                required: true,
                message: "Please Enter Amount",
              },
              {
                pattern: new RegExp(/^[0-9\b]+$/),
                message: "Please enter valid number!",
              },
            ]}
            className="form_item_blue"
          >
            <Input
              onChange={onChangePricePerPerson}
              placeholder="Please Enter Amount"
            />
          </Form.Item>
          {packagePricingBreakdown?.packageAmount && (
            <div className="breakdown_wrapper">
              <h3>Breakdown(s)</h3>
              <div className="price_box">
                <h3>Package 1</h3>
                <ul>
                  <li>
                    <div>
                      <p>
                        {allPackageList &&
                          allPackageList.map((pk: any) => {
                            return pk._id === packageId ? pk.package : <></>;
                          })}{" "}
                        Membership -{" "}
                        {paymentDuration === "6-month"
                          ? "6 months"
                          : "12 months"}
                      </p>
                    </div>
                    <div>
                      <p>
                        ₹
                        {Number(packagePricingBreakdown?.packageAmount).toFixed(
                          2
                        ) || 0}
                      </p>
                    </div>
                  </li>
                  {isEmployees !== 0 && (
                    <li>
                      <div>
                        <p>Unit</p>
                      </div>
                      <div>
                        <p>{isEmployees}</p>
                      </div>
                    </li>
                  )}
                  {isPricePerPerson !== 0 && (
                    <li>
                      <div>
                        <p>Price Per Person</p>
                      </div>
                      <div>
                        <p>₹{Number(isPricePerPerson)?.toFixed(2)}</p>
                      </div>
                    </li>
                  )}

                  <li className="tax_details">
                    <div className="line">
                      <div>
                        <p>+ Taxes/ IGST (18%)</p>
                      </div>
                      <div>
                        <p>
                          ₹{packagePricingBreakdown?.igstTax?.toFixed(2) || 0}
                        </p>
                      </div>
                    </div>

                    <div className="line tax" style={{ marginTop: "8px" }}>
                      <div className="gray">
                        <p>CGST (9%)</p>
                      </div>
                      <div>
                        <p>
                          ₹{packagePricingBreakdown?.cgstTax?.toFixed(2) || 0}
                        </p>
                      </div>
                    </div>
                    <div className="line tax">
                      <div className="gray">
                        <p>SGST/UTGST (9%)</p>
                      </div>
                      <div>
                        <p>
                          ₹{packagePricingBreakdown?.sgstTax?.toFixed(2) || 0}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="total_amount border">
                    <div>
                      <p>Total Amount</p>
                    </div>
                    <div>
                      <p>
                        ₹
                        {packagePricingBreakdown?.subTotalAmount?.toFixed(2) ||
                          0}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* <div className="yellow_tip_box">
            <p style={{ marginBottom: "16px" }}>
              Enter the <strong>Package Amount </strong> in the form after
              calculating it manually. For invoicing purposes, please also
              provide the <strong>Price Per Person, Per Month</strong>{" "}
              separately.
            </p>
            <p>Note: This will not affect the total package amount entered.</p>
          </div> */}

          <CheckboxList
            preSelectPackages={preSelectPackages}
            modules={memberModules}
          />

          {packagePricingBreakdown?.subTotalAmount && (
            <div className="breakdown_subtotal">
              <div>
                <p>Subtotal</p>
              </div>
              <div>
                <p>
                  ₹{packagePricingBreakdown?.subTotalAmount ?? 0}
                  .00
                </p>
              </div>
            </div>
          )}

          <div className="verifi_checkbox">
            <Checkbox onChange={VerifiedPackage}></Checkbox>
            <p>I have thoroughly verified all the details.</p>
          </div>
          <Form.Item style={{ marginBottom: "10px" }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={btnDisable ? true : false}
              className="cn_btn"
              style={{ margin: "24px auto 0", width: "100%" }}
            >
              Confirm & Proceed
            </Button>
          </Form.Item>
        </Form>
      </AppModal>
    </>
  );
}

export default PlanChangeTable;
